"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Toggle = _interopRequireDefault(require("../../helpers/Toggle"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _CardSlider = _interopRequireDefault(require("../../CardSlider/CardSlider"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var FlexHighlightGrid = function FlexHighlightGrid(_ref) {
  var title = _ref.title,
    highlights = _ref.highlights;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm margin-bottom-sm"
  }, title || 'Highlights'), /*#__PURE__*/_react["default"].createElement(_CardSlider["default"], null, highlights.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
      key: JSON.stringify(item)
    }, function (_ref2) {
      var toggle = _ref2.toggle,
        on = _ref2.on;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "mobile-wide-cards padding-y-sm padding-right-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        template: "ImageCard",
        className: "d8-u-hover-shadow-xl",
        imageCardTemplate: "Basic",
        bgImage: {
          url: item.featured_image_src,
          alt: item.title.rendered
        },
        whiteFont: true,
        overlay: true,
        size: "xs",
        onClick: toggle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "justify-end height-100% width-100% flex flex-1 relative"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "absolute",
        style: {
          top: -24,
          right: -24
        }
      }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        name: "info-i-fill",
        className: "icon--md"
      })))), /*#__PURE__*/_react["default"].createElement("p", {
        className: "d8-u-text-bold text-md margin-top-sm"
      }, item.title.rendered), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        style: {
          width: 'var(--max-width-xxs)',
          minWidth: 'unset'
        },
        template: "MediaModal",
        on: on,
        toggle: toggle,
        title: item.title.rendered.replace(/<[^>]*>/g, ''),
        text: item.content.rendered.replace(/<[^>]*>/g, ''),
        image: {
          url: item.featured_image_src,
          alt: item.title.rendered.replace(/<[^>]*>/g, '')
        },
        video: item.acf && item.acf.video
      }));
    });
  })));
};
FlexHighlightGrid.propTypes = {
  title: _propTypes["default"].string,
  highlights: _propTypes["default"].array
};
var _default = exports["default"] = FlexHighlightGrid;